import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import * as roomWSS from "./services/roomWSS";

import Account from "./ui/Account";
import Home from "./ui/Home";
import Room from "./ui/Room";

import "./App.css";

const SESSION_ID = process.env.REACT_APP_SESSION_ID;

const App = () => {
    useEffect(() => {
        const effectSocketConnect = async () => {
            await roomWSS.connectRoomSocketIOServer();
        };

        effectSocketConnect();
    }, []);

    useEffect(() => {
        roomWSS.createSession(true, "Administrador", SESSION_ID);
    }, []);

    return (
        <Router
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
            }}>
            <Routes>
                <Route path="/" element={<Account />} />
                <Route path="/home" element={<Home />} />
                <Route path="/room" element={<Room />} />
            </Routes>
        </Router>
    );
};

export default App;